/**
 * Checks whether the given location pathnames are different.
 *
 * @see isDifferentLocationUtil
 *
 * @param  {Object} location1
 * @param  {Object} location2
 * @returns {boolean}
 */
export default function isDifferentLocationWithoutQueryLocationUtil (location1, location2) {
  return (
    location1 &&
    location2 &&
    location1?.pathname !== location2?.pathname
  )
}
